import React from 'react';

const FormField = ({
  label,
  name,
  type = 'text',
  register,
  validation = {},
  error,
  placeholder,
  options = [], // For select fields
  className = '',
  required = false,
  ...props
}) => {
  const baseInputClasses = `
    mt-1 block w-full px-3 py-2 border rounded-md shadow-sm 
    focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 
    transition-colors duration-200 sm:text-sm
    ${error 
      ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500' 
      : 'border-gray-300 text-gray-900 placeholder-gray-400'
    }
    ${className}
  `;

  const renderInput = () => {
    if (type === 'select') {
      return (
        <select
          id={name}
          {...register(name, validation)}
          className={baseInputClasses}
          {...props}
        >
          <option value="">{placeholder || `Select ${label}`}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      );
    }

    if (type === 'checkbox') {
      return (
        <div className="flex items-center">
          <input
            id={name}
            type="checkbox"
            {...register(name, validation)}
            className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded transition-colors duration-200"
            {...props}
          />
          <label htmlFor={name} className="ml-2 block text-sm text-gray-700">
            {label}
          </label>
        </div>
      );
    }

    return (
      <input
        id={name}
        type={type}
        placeholder={placeholder}
        {...register(name, validation)}
        className={baseInputClasses}
        {...props}
      />
    );
  };

  if (type === 'checkbox') {
    return (
      <div className="space-y-1">
        {renderInput()}
        {error && (
          <p className="text-xs text-red-600 flex items-center">
            <svg className="h-3 w-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            {error.message}
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-1">
      <label htmlFor={name} className="block text-sm font-medium text-gray-700">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {renderInput()}
      {error && (
        <p className="text-xs text-red-600 flex items-center">
          <svg className="h-3 w-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          {error.message}
        </p>
      )}
    </div>
  );
};

export default FormField;
